export const layoutValues = ['grid', 'list'] as const;
export type LayoutType = (typeof layoutValues)[number];

export const sortValues = [
  'name',
  'lastModified',
  'createdAt',
  'draft',
  'version'
] as const;
export type SortType = (typeof sortValues)[number];

export type ActiveOptionsType = {
  layout?: LayoutType;
  sort?: SortType;
  searchText?: string;
  filters?: Record<string, string[]>;
};

export type ContentHeaderContextValue = {
  layout: LayoutType;
  onLayoutChange: (layout: LayoutType) => void;
  handleSelectFilter: (filterKey: string, selected: string[]) => void;
  sort: SortType;
  onSortChange: (sort: SortType) => void;
  searchText: string;
  onInputChange: (value: string) => void;
  searchCallback?: (activeOptions: ActiveOptionsType) => void;
  activeOptions: ActiveOptionsType;
  isLoaded: boolean;
};
